<template>
  <div :class='wrpCls'>

    <div class='header_right'>

      <div class="notice">
        <div class="notice_title">公告：</div>
        <div class="scroll-container" @mouseenter="stopScroll" @mouseleave="startScroll">
          <div class="scroll-content" ref="scrollContent">
            <div v-for="item in items" :key="item.id" class="scroll-item" @click="setLink(item)">
              <div v-if="item.type==1">{{setContent(item)}}</div>
              <div v-else-if="item.type==3 && item.id>0 && item.content=='订单'">您有新的订单请进行处理！</div>
              <div v-else-if="item.type==3 && item.id>0 && item.content=='售后'">您有新的售后订单请进行处理！</div>
            </div>
            <div class="scroll-item" v-if="typeName=='kf' && messageNum!=0 && $route.path!='/kf/shop/shopkf'" @click="getMessageLook">您有新的未读消息请及时查看！</div>
          </div>
        </div>
      </div>
      <div>账户余额：{{ balance }}</div>

      <a-button type='primary' :href="modeType=='development'?'http://localhost':'https://acc-admin.shiwei.love'"
                target='_blank' class='recharge'>充值
      </a-button>
      <a-space size='middle'>
        <screenfull />
        <notice-icon v-hasPermi="['system:notice:list']" style='cursor: pointer;' />
        <avatar-dropdown :menu='showMenu' :current-user='currentUser' :class='prefixCls' />
             <select-lang :class="prefixCls" />
      </a-space>
    </div>
  </div>
</template>

<script>
import {pageShop, listShop, delShop, updateShopRecommend,ptkf,queryAutographSign,queryKfUserList,
queryKfNoticePage,
queryKfNoticeCount,
addKfNoticeCount,queryKfUserQusetion,queryKfUserLists,queryKfUserChatMessage} from '@/api/shop/shop'
import AvatarDropdown from './AvatarDropdown'
import NoticeIcon from '@/components/NoticeIcon'
import Screenfull from '@/components/Screenfull'
import SelectLang from '@/components/SelectLang'
import { getAccountBalance } from '@/api/system/user'
import { showNotice } from '@/api/system/notice'
import { mapGetters } from 'vuex'
const RongIMLib = require('@rongcloud/imlib-next')
export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    NoticeIcon,
    Screenfull,
    SelectLang
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action'
    },
    isMobile: {
      type: Boolean,
      default: () => false
    },
    topMenu: {
      type: Boolean,
      required: true
    },
    theme: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      msgArry:[],
      listShop:[
        {
          id:1,
          unreadMessageCount:1
          
        },{
          id:1,
          unreadMessageCount:0
          
        }
      ],
      messageNum:0,
      typeName:'',
      items: [ // 示例数据数组
        { id: 1, text: '中台运费模版内容已更新！' },
        { id: 2, text: '推广合租那个圆运费模版内容已修改！' },
        { id: 3, text: '阿斯顿法师打发手打手动阀萨芬大叔大婶打发第三方大沙发·！' },
        // 更多项...
      ],
      animationPaused: false, // 控制动画是否暂停的标志位
      modeType: process.env.NODE_ENV,
      balance: 0,
      showMenu: true,
      currentUser: {},
      docUrl: process.env.VUE_APP_URL_AGREEMENT + process.env.VUE_APP_URL_HOST + process.env.VUE_APP_BASE_API + '/doc',
      githubUrl: 'http://gitlab.niurenjianzhan.com/zhangxun/java-framework'
    }
  },
  computed: {
    ...mapGetters(['roles']),
    wrpCls() {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${(this.isMobile || !this.topMenu) ? 'light' : this.theme}`]: true
      }
    }
  },
  mounted() {
    console.log(this.roles,'asdfasdfasdfsadfdsaf',this.$route.path);

    if (this.roles.includes('kf')) {
      this.typeName = 'kf'
      this.messageLook()
      this.loginKf('init')
    } else {
       this.typeName = ''
      console.log('数组不包含该值');
    }


    
    setInterval(() => { 
      this.getShowNotice()
      let num =  localStorage.getItem('messageNum')
      this.$set(this,'messageNum',num)
      

    }, 3000)
    
    setTimeout(() => {
      this.currentUser = {
        name: 'RuoYi'
      }
    }, 1500)
    getAccountBalance().then(res => {
        this.balance = res.data
        console.log(res, 'getAccountBalance')
      }
    )
  },
  methods: {

  messageLook(){
          console.log('监听')
          let that = this;
          // 2 设置监听   3 登录IM  4.获取会话列表
            const Events = RongIMLib.Events
            RongIMLib.addEventListener(Events.CONNECTING, () => {
                console.log('正在链接服务器')
            })
            RongIMLib.addEventListener(Events.CONNECTED, () => {
                console.log('已经链接到服务器')
            })
            RongIMLib.addEventListener(Events.MESSAGES, (evt) => {
                console.log('消息监听',evt.messages)
                if(evt.messages[0].targetId == this.selectId){
                  that.$refs.msglist.upDataList(evt.messages[0]) 
                  that.readMessage(evt.messages[0])
                }
                RongIMLib.getConversationList().then((e) => {
                    if (e.code === 0) {
                      let dataArry = e.data.filter((item)=>{
                        item.targetId.includes('kf')
                    })

                    let userId = e.data.map(e=>{
                      
                      return e.targetId
                    })
                    console.log('过滤会话列表成功7777777', userId);
                    let userIds = userId.filter(e=>{
                      return e.indexOf('kf') == -1; 
                    })
                    console.log('过滤会话列表成功8888888888', userIds);
                      console.log('获取会话列表成功11111', e);
                      queryKfUserList({userIds:userIds}).then(response => {
                        console.log('用户列表',response)
                        console.log('会话列表1111',e)
                        let array = response.data.map(item=>{
                          let mergedObj = '' 
                          for(let i = 0 ; i < e.data.length; i++ ){
                                // console.log('获取客服列表4',res2.data.data[i].targetId, e.targetId)
                                if(item.id == e.data[i].targetId) {
                                  
                                  mergedObj = Object.assign({}, e.data[i],item);
                                  
                                  // console.log('获取客服列表5',mergedObj)
                                  //return mergedObj
                                }
                              
                              }
                              return mergedObj
                      
                        })

                        // this.rongyunToken = response.data.tenCenImSig;
                        
                        console.log('过滤会话列表成功2', array);
                        this.msgArry = array

                        let total = 0;
                        this.msgArry.forEach(shop => {
                          total += shop.unreadMessageCount;
                        });
                  
                        this.$set(this, 'messageNum', total);
                        localStorage.setItem('messageNum', total)


           
                        
                              
                        // 获取会话用户信息
                        // let openUrl ='http://kf.qyg1001.com/dist?id='+response.data.id+''+'&usersig='+response.data.tenCenImSig;
                        // window.open(openUrl, 'kfWidow',"444");
                      })
                      // this.msgArry = e.data
                      // this.selectId = e.data[0].targetId
                    } else {
                      console.log('获取会话列表失败: ', e);
                    }
              });
            })



        },

    /** 获取客服imtoken **/
    loginKf(type) {
      let that = this;
      ptkf().then(response => {
        console.log('客服',response)
        this.myUserInfo = response.data
        this.rongyunToken = response.data.tenCenImSig
        console.log(response.data,"response.data")
        console.log(this.rongyunToken,"this.rongyunToken")
        this.rongyunId = response.data.id
        if(type == 'init'){
          this.loginIm()
        }
        // let openUrl ='http://kf.qyg1001.com/dist?id='+response.data.id+''+'&usersig='+response.data.tenCenImSig;
        // window.open(openUrl, 'kfWidow',"444");
      })
      
    },

    async loginIm(){
      console.log('初始化----')
      let that = this;
      let token =  this.rongyunToken;
      const res =  await RongIMLib.connect(token);
      console.log('初始化----',res)
        // 4.获取会话列表
        RongIMLib.getConversationList().then((e) => {
          if (e.code === 0) {
            console.log('获取会话列表成功', e);

            let dataArry = e.data.filter((item)=>{
                item.targetId.includes('kf')
            })

            let userId = e.data.map(e=>{
							
							return e.targetId
						})
            console.log('过滤会话列表成功11111', userId);
            let userIds = userId.filter(e=>{
               return e.indexOf('kf') == -1; 
            })
            console.log('过滤会话列表成功222222', userIds);
            
            queryKfUserList({userIds:userIds}).then(response => {
              console.log('用户列表',response)
              console.log('会话列表',e)
              let array = response.data.map(item=>{
                let mergedObj = '' 
                for(let i = 0 ; i < e.data.length; i++ ){
											// console.log('获取客服列表4',res2.data.data[i].targetId, e.targetId)
											if(item.id == e.data[i].targetId) {
												
												mergedObj = Object.assign({}, e.data[i],item);
												
												 // console.log('获取客服列表5',mergedObj)
												 //return mergedObj
											}
                    
										}
                    return mergedObj
            
              })

              // this.rongyunToken = response.data.tenCenImSig;
              
              // console.log('过滤会话列表成功2', userIds);
              let a = []
              let b = []
              array.map(i => {
                if(i.isTop) {
                  a.push(i)
                } else {
                  b.push(i)
                }
              })
              this.msgArry = [...a,...b]

              let total = 0;
              this.msgArry.forEach(shop => {
                total += shop.unreadMessageCount;
              });
   
              this.$set(this, 'messageNum', total);
              localStorage.setItem('messageNum', total)


              // this.msgArry = array
              // 获取会话用户信息

              console.log('用户列表111111111',array)
            })
      


          
          } else {
            console.log('获取会话列表失败: ', e);
          }
        });


         // RTC 客户端初始化
        // const rtcClient = RongIMLib.installPlugin(rtcInstaller, { /* 配置项 */ })
        // console.log('初始化22222222',rtcClient)
        // that.caller = RongIMLib.installPlugin(callInstaller,{
        // // rtcClient 实例 （必填）
        // rtcClient,
        // /**
        //  * 被动收到邀请 （收到一个远端发起的新会话）, 会产生一个新的 session 对象 （必填）
        //  */
        // onSession: (session) => {
        //   console.log(`收到的通话邀请`);
          
          
        //     /**
        //      * **收到新的 session 后需要立即注册事件监听**
        //      */
        //     that.registerCallSessionEvent(session);

        //     that.callGet(session);
        // },
        // onSessionClose: (session, summary) => {
        //     console.log('通话已结束1',summary,session)
        //     that.dialogYinShiPin = false;
        //     that.yinshipinType = 0;
        //       // RCToast('通话已结束');
        //       // RCCallView.end();
        //       // removeVideoEl();
        // },
        //  /**
        //  * 接收 IM 离线期间收到的呼叫记录（按需监听）
        //  */
        // onOfflineRecord(record){
        //   console.log('通话已结束2',summary,session)
        // },
        // });
        // console.log('初始化完成')
      },
    
    getMessageLook(){
      this.$router.push({
          path: '/kf/shop/shopkf',
         
        })

    },
    // 路由跳转
    setLink(row){
      if(row.type == 3 && row.content == '订单'){
        this.$router.push({
          path: '/order/sell',
         
        })
        
      }

      if(row.type == 3 && row.content == '售后'){
        this.$router.push({
          path: '/order/refund',
         
        })
        
      }

      if(row.type == 1){

        this.$router.push({
          name: 'NewForm',
          params:
          {
            id: row.id,
            formTitle: '公告编辑'
          }
        })
       
        
      }
      if(row.type == 2){
        this.$router.push({
          path: '/kf/shop/shopkf',
         
        })
        
      }
      
      
    },
    setContent(row){
      let text = JSON.parse(row.content)
      return text.title
    },
    getShowNotice(){
      showNotice().then(res => {
        if(res.code=='20001'){
          this.items = res.data.data
        }
        console.log('header,header,header,header，header',res);
        
      })
    },
    stopScroll() {
      this.animationPaused = true; // 停止动画时设置标志位为true
      this.$refs.scrollContent.style.animationPlayState = 'paused'; // 暂停动画
    },
    startScroll() {
      if (this.animationPaused) { // 如果之前是暂停状态，则恢复动画
        this.animationPaused = false; // 重置标志位为false
        this.$refs.scrollContent.style.animationPlayState = 'running'; // 恢复动画播放状态为running
      }
    },
    toDoc() {
      window.open(this.docUrl)
    }
    ,
    toGithub() {
      window.open(this.githubUrl)
    }
  }
}
</script>
<style scoped>
.header_right {
  display: flex;
  align-items: center;
}

.recharge {
  margin-left: 20px;
}

.notice{
width: 800px;
overflow: hidden;
display: flex;
justify-content: center;

}

.scroll-container {
  width: 100%; /* 根据需要调整 */
  overflow: hidden; /* 隐藏溢出的内容 */
  white-space: nowrap; /* 防止内容换行 */
  cursor: pointer;

}
 
.scroll-content {
  display: inline-block;
  animation: scroll 10s linear infinite; /* 初始动画设置 */
}
 
.scroll-item {
  display: inline-block;
  margin-right: 20px; /* 根据需要调整间距 */
}
 
@keyframes scroll {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100%);
  }
}
.notice_title{
  width: 70px;
}

</style>